__turbopack_context__.v({
  "className": "PARSka_className",
  "variable": "PARSka_variable",
});
